export const ROW_HEIGHT = 40
export const ICON_TICK_SIZE = 20
const HOLD_SECONDS = 5
const TRANSITION_SECONDS = 0.4
export const STEP_SECONDS = HOLD_SECONDS + TRANSITION_SECONDS
export const HOLD_FRACTION = HOLD_SECONDS / STEP_SECONDS
export const INLINE_TICKER_MESSAGES_ROW = 4
